import type { MfgOverheadPeriodBucketRow } from "@/lib/manufacturing/overheadTypes";

export type OverheadPeriodDraft = {
  assumed: string;
  actual: string;
  reason: string;
};

type DraftRow = Pick<MfgOverheadPeriodBucketRow, "bucket_id" | "assumed_value_usd" | "actual_value_usd">;

function moneyDraft(value: number | null): string {
  return value == null ? "" : String(value);
}

export function draftsForLoadedPeriod(
  previous: Record<string, OverheadPeriodDraft>,
  previousPeriod: string,
  loadedPeriod: string,
  rows: DraftRow[],
): Record<string, OverheadPeriodDraft> {
  const source = previousPeriod === loadedPeriod ? previous : {};
  const next: Record<string, OverheadPeriodDraft> = {};
  for (const row of rows) {
    const existing = source[row.bucket_id];
    next[row.bucket_id] = {
      assumed: existing?.assumed ?? moneyDraft(row.assumed_value_usd),
      actual: existing?.actual ?? moneyDraft(row.actual_value_usd),
      reason: existing?.reason ?? "",
    };
  }
  return next;
}
